import type { Battle } from './battle.type';
import type { MapEvent } from './events.type';

/** What visiting a node does; its icon is chosen separately. */
export enum MapNodeType {
  Battle = 'battle',
  Boss = 'boss',
  Event = 'event',
  Town = 'town',
  /** Visited, or otherwise spent: nothing left to do there. */
  Clear = 'clear',
}

export type MapNode = {
  id: number;
  group: number;
  shape: string;
  color: string;
  size?: number;
  shadow?: boolean;
  visit: Function;

  type?: MapNodeType;
  icon?: string;
  image?: string;

  visited: boolean;
  scouted: boolean;
  open: boolean;

  x?: number;
  y?: number;
  pathLength?: number;

  battle?: Battle;
  event?: MapEvent;
};

export type MapEdge = {
  from: string | number;
  to: string | number;
  dashes: boolean;
};

export type MapData = {
  nodes: Array<MapNode>;
  edges: Array<MapEdge>;

  innerNodes: Array<MapNode>;
  middleNodes: Array<MapNode>;
  outerNodes: Array<MapNode>;
  edgeNodes: Array<MapNode>;
};
